/**
 * Pixen Intrigue — English overrides, composed from per-feature fragments.
 * Only keys whose shared-shell (Grymwyrd-voiced) English carries world flavor are
 * re-voiced here in the courtly-fae register; every generic UI key is inherited
 * from `baseEn`. Composed into `WorldConfig.content.en` as
 * `{ ...baseEn, ...pixEn }`.
 */
import { layoutPixEn } from './en/layout'
import { homePixEn } from './en/home'
import { playPixEn } from './en/play'
import { demoPixEn } from './en/demo'
import { booksPixEn } from './en/books'
import { commercePixEn } from './en/commerce'
import { communityPixEn } from './en/community'
import { dashboardPixEn } from './en/dashboard'
import { authPixEn } from './en/auth'
import { marketingPixEn } from './en/marketing'
import { worldPixEn } from './en/world'
import { encyclopediaPixEn } from './en/encyclopedia'
import { systemPixEn } from './en/system'
import type { MessageCatalog } from '@gamecodex/world-config'

export const pixEn: MessageCatalog = {
  ...layoutPixEn,
  ...homePixEn,
  ...playPixEn,
  ...demoPixEn,
  ...booksPixEn,
  ...commercePixEn,
  ...communityPixEn,
  ...dashboardPixEn,
  ...authPixEn,
  ...marketingPixEn,
  ...worldPixEn,
  ...encyclopediaPixEn,
  ...systemPixEn,
}
